var _excluded = ["hasWindowButton", "buttons", "buttonsAlignment", "children", "closeModal", "defaultPosition", "positionOffset", "height", "icon", "menu", "title", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import styled, { css, th } from '@xstyled/styled-components';
import * as React from 'react';
import Draggable from 'react-draggable';
import Button from '../Button';
import TitleBar from '../TitleBar';
import ModalContext from './ModalContext';
var ModalWrapper = styled.div.withConfig({
  displayName: "Modal__ModalWrapper",
  componentId: "sc-4ouk59-0"
})(["\n  display: flex;\n  flex-direction: column;\n\n  position: fixed;\n\n  padding: 2 2 8;\n\n  top: 50px;\n\n  background-color: material;\n\n  box-shadow: inset 1px 1px 0px 1px ", ",\n    inset 0 0 0 1px ", ",\n    1px 1px 0 1px ", ";\n\n  ", "\n  ", "\n"], th('colors.borderLightest'), th('colors.borderDark'), th('colors.borderDarkest'), function (_ref) {
  var width = _ref.width,
    height = _ref.height;
  return "\n    width: ".concat(width ? "".concat(width, "px") : 'auto', ";\n    height: ").concat(height ? "".concat(height, "px") : 'auto', ";\n  ");
}, function (_ref2) {
  var active = _ref2.active;
  return active ? css(["\n          z-index: modal;\n        "]) : '';
});
var Content = styled.div.withConfig({
  displayName: "Modal__Content",
  componentId: "sc-4ouk59-1"
})(["\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n\n  padding: 6;\n"]);
var ButtonWrapper = styled.div.withConfig({
  displayName: "Modal__ButtonWrapper",
  componentId: "sc-4ouk59-2"
})(["\n  display: flex;\n  flex-direction: row;\n  justify-content: ", ";\n\n  padding: 0 6 6 6;\n\n  & ", " {\n    margin-right: 6;\n    min-width: 70px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"], function (_ref3) {
  var _ref3$buttonsAlignmen = _ref3.buttonsAlignment,
    buttonsAlignment = _ref3$buttonsAlignmen === void 0 ? 'center' : _ref3$buttonsAlignmen;
  return buttonsAlignment;
}, Button);
var MenuWrapper = styled.ul.withConfig({
  displayName: "Modal__MenuWrapper",
  componentId: "sc-4ouk59-3"
})(["\n  display: flex;\n  flex-direction: row;\n\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n  padding-bottom: 3;\n\n  border-bottom-style: solid;\n  border-width: 1;\n  border-bottom-color: borderDark;\n\n  box-shadow: 0 1px 0 0 ", ";\n"], th('colors.borderLighter'));
var MenuItem = styled.li.withConfig({
  displayName: "Modal__MenuItem",
  componentId: "sc-4ouk59-4"
})(["\n  position: relative;\n  padding-left: 6;\n  padding-right: 6;\n\n  user-select: none;\n\n  ul {\n    position: absolute;\n    left: 0;\n    color: ", ";\n  }\n\n  ", ";\n"], th('colors.materialText'), function (_ref4) {
  var active = _ref4.active;
  return active && css(["\n      background-color: primary;\n      color: materialTextInvert;\n    "]);
});
MenuItem.displayName = 'MenuItem';
var ModalRenderer = function ModalRenderer(_ref5, ref) {
  var _ref5$hasWindowButton = _ref5.hasWindowButton,
    hasButton = _ref5$hasWindowButton === void 0 ? true : _ref5$hasWindowButton,
    buttons = _ref5.buttons,
    buttonsAlignment = _ref5.buttonsAlignment,
    children = _ref5.children,
    closeModal = _ref5.closeModal,
    defaultPosition = _ref5.defaultPosition,
    positionOffset = _ref5.positionOffset,
    height = _ref5.height,
    icon = _ref5.icon,
    menu = _ref5.menu,
    title = _ref5.title,
    width = _ref5.width,
    rest = _objectWithoutProperties(_ref5, _excluded);
  var _React$useContext = React.useContext(ModalContext),
    addWindows = _React$useContext.addWindows,
    removeWindow = _React$useContext.removeWindow,
    updateWindow = _React$useContext.updateWindow,
    setActiveWindow = _React$useContext.setActiveWindow,
    activeWindow = _React$useContext.activeWindow;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    id = _React$useState2[0],
    setId = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    menuOpened = _React$useState4[0],
    setMenuOpened = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isActive = _React$useState6[0],
    setIsActive = _React$useState6[1];
  React.useEffect(function () {
    if (!id) {
      var newId = addWindows({
        icon: icon,
        title: title,
        hasButton: hasButton
      });
      if (newId) {
        setId(newId);
        setActiveWindow(newId);
      }
    } else {
      updateWindow(id, {
        icon: icon,
        title: title,
        hasButton: hasButton
      });
    }
  }, [id, icon, title, hasButton]);
  React.useEffect(function () {
    return function () {
      if (id) {
        removeWindow(id);
      }
    };
  }, [id]);
  React.useEffect(function () {
    return setIsActive(id === activeWindow);
  }, [id, activeWindow]);
  return /*#__PURE__*/React.createElement(Draggable, {
    handle: ".draggable",
    defaultPosition: defaultPosition,
    positionOffset: positionOffset,
    onMouseDown: id ? function () {
      return setActiveWindow(id);
    } : undefined
  }, /*#__PURE__*/React.createElement(ModalWrapper, _extends({
    width: width,
    height: height
  }, rest, {
    active: isActive,
    ref: ref
  }), /*#__PURE__*/React.createElement(TitleBar, {
    active: isActive,
    icon: icon,
    title: title,
    className: "draggable"
  }, /*#__PURE__*/React.createElement(TitleBar.OptionsBox, null, /*#__PURE__*/React.createElement(TitleBar.Option, null, "?"), /*#__PURE__*/React.createElement(TitleBar.Option, {
    onClick: closeModal
  }, "X"))), menu && menu.length > 0 && /*#__PURE__*/React.createElement(MenuWrapper, null, menu.map(function (_ref6) {
    var name = _ref6.name,
      list = _ref6.list;
    var active = menuOpened === name;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: name,
      onMouseDown: function onMouseDown() {
        return setMenuOpened(name);
      },
      active: active
    }, name, active && list);
  })), /*#__PURE__*/React.createElement(Content, {
    onClick: function onClick() {
      return setMenuOpened('');
    }
  }, children), buttons && buttons.length > 0 && /*#__PURE__*/React.createElement(ButtonWrapper, {
    buttonsAlignment: buttonsAlignment
  }, buttons.map(function (button) {
    return /*#__PURE__*/React.createElement(Button, {
      key: button.value,
      onClick: button.onClick,
      value: button.value
    }, button.value);
  }))));
};
var Modal = /*#__PURE__*/React.forwardRef(ModalRenderer);
Modal.displayName = 'Modal';
Modal.defaultProps = {
  icon: undefined,
  title: 'Modal',
  buttonsAlignment: 'flex-end',
  children: null,
  defaultPosition: {
    x: 0,
    y: 0
  },
  buttons: [],
  menu: [],
  width: undefined,
  height: undefined,
  closeModal: function closeModal() {}
};
export default Modal;